import { ca } from '@cian/analytics';

export function trackPromoBuilderOffersShow({
  realtyUserId,
  title,
  builderCardUrl,
}: {
  realtyUserId: number;
  title: string;
  builderCardUrl: string;
}): void {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'show_sopr',
    label: 'specproject_carousel',
    page: {
      extra: {
        is_specproject: true,
        hit_url: builderCardUrl,
        carousel_name: title,
        carousel_place: 'below_listing',
      },
    },
    products: [
      {
        id: realtyUserId,
        offerType: 'userid',
      },
    ],
  });
}
